export const MIN_GROSS_INCOME = 20_000_000;
export const MAX_GROSS_INCOME = 10000_000_000;
